import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';
import palette from '../../../styles/palette';

export const useStyles = makeStyles<Theme>()((theme) => ({
  menuContainer: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: '4px',
    minWidth: '246px',
    maxHeight: '500px',
    overflowY: 'auto',
    lineHeight: '1',
    boxShadow: '0 4px 8px 0 rgba(19, 15, 38, 0.08)',

    '& > ul': {
      padding: '0',

      '& svg': {
        color: palette.grey[600],
      },
    },
  },

  menuBackground: {},

  alignTop: {},
}));
